import React from 'react';

const IntegrationWizardContext = React.createContext({});

export const useIntegrationWizard = () => React.useContext(IntegrationWizardContext);

export default IntegrationWizardContext;
